export function getQueryParam(name: string) {
  try {
    const query = window.location.search.substring(1);
    const params = query.split('&');
    for (let i = 0; i < params.length; i += 1) {
      const pair = params[i].split('=');
      if (decodeURIComponent(pair[0]) === name) {
        return decodeURIComponent(pair[1]);
      }
    }
    return null;
  } catch {
    return null;
  }
}

export const constructRoute = (base: string, path: string) =>
  `${base}${base.endsWith('/') ? '' : '/'}${path}`;
